import { Injectable } from '@angular/core';
import { autoUnsubscribeMixin } from '@core/helpers/auto-unsubscribe.mixin';
import { ApplicationsDto, BranchDto, PaginatedResponseDto, ProductDto, UserDto } from '@core/services/dto';
import { ApplicationsModel, ProductModel } from '@shared/models';
import { ApplicationsApiService } from '@core/services/api.services';
import { BehaviorSubject, map, Observable, Subject } from 'rxjs';
import { ApplicationResumeByStaff, NewApplicationStartByStaff } from '@shared/models/requests/ApplicationResumeByStaff.request.dto';

@Injectable({
  providedIn: 'root'
})
export class ApplicationListStateService extends autoUnsubscribeMixin() {
  public data: Subject<PaginatedResponseDto<ApplicationsModel>> = new Subject<PaginatedResponseDto<ApplicationsModel>>();
  public products: BehaviorSubject<ProductModel[]> = new BehaviorSubject<ProductModel[]>([]);
  constructor(private service: ApplicationsApiService) {
    super();
  }

  data$(): Observable<PaginatedResponseDto<ApplicationsModel>> {
    return this.data.asObservable();
  }

  products$(): Observable<ProductModel[]> {
    return this.products.asObservable();
  }

  getData(request: any): void {
    this.service.getApplications(request).pipe(map((response: any) => {
      const paginated = response.result;
      return {
        ...response,
        data: paginated.item.map((item: ApplicationsDto) => new ApplicationsModel(item)),
        totalCount: response.result.totalCount,
        totalPages: response.result.totalPages,
        pageNumber: response.result.pageNumber
      };
    }
    )
    ).subscribe(
      data => {
        this.data.next(data);
      }
    );
  }
  applicationResumeByStaff(request: ApplicationResumeByStaff): Observable<any> {
    return this.service.applicationResumeByStaff(request);
  }
  getBranches(): Observable<{ result: BranchDto[] }> {
    return this.service.getBranches();
  }
  getStaffUsers(): Observable<{ result: UserDto[] }> {
    return this.service.getStaffUsers();
  }

  getProducts(productType?: number): void {
    this.service.getProducts(productType).pipe(map((response: PaginatedResponseDto<ProductDto>) =>
      response.data.map((item) => new ProductModel(item))
    )).subscribe((data) => {
      this.products.next(data);
    });
  }

  export(request: any): Observable<{ jobId: string; status: string; message: string }> {
    return this.service.exportApplication(request);
  }

  getStatus(jobId: string): Observable<{ jobId: string; status: string }> {
    return this.service.getExportStatus(jobId);
  }

  download(jobId: string): Observable<Blob> {
    return this.service.downloadExport(jobId);
  }

  newApplicationStartByStaff(request: NewApplicationStartByStaff): Observable<any> {
    return this.service.newApplicationStartByStaff(request);
  }
}
